var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1667C9.78725 14.1656 9.57742 14.1172 9.38572 14.0249C9.19401 13.9327 9.02525 13.7989 8.89166 13.6333L5.38333 9.38332C5.17833 9.12746 5.04932 8.81916 5.01101 8.49355C4.9727 8.16793 5.02664 7.83811 5.16666 7.54166C5.28023 7.28401 5.46556 7.0645 5.70051 6.90934C5.93547 6.75418 6.21012 6.66993 6.49166 6.66666H13.5083C13.7899 6.66993 14.0645 6.75418 14.2995 6.90934C14.5344 7.0645 14.7198 7.28401 14.8333 7.54166C14.9734 7.83811 15.0273 8.16793 14.989 8.49355C14.9507 8.81916 14.8217 9.12746 14.6167 9.38332L11.1083 13.6333C10.9747 13.7989 10.806 13.9327 10.6143 14.0249C10.4226 14.1172 10.2127 14.1656 10 14.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownFill);
export default __webpack_public_path__ + "static/media/arrowDownFill.6f5ca8823d462c590e85ec3cea76f6ac.svg";
export { ForwardRef as ReactComponent };